import React from 'react';
import Loader_9 from '../../loaders/Loader-9';

const LoadPayment = () => {
  return (
    <div className="text-center py-5 d-flex flex-column justify-content-center align-items-center h-100">
      <Loader_9 />
      <div className="fs-6 fw-semibold py-5">Let's payment process to complete...</div>
    </div>
  );
};

export default LoadPayment;
